import { QuestionPassStateId } from '../../../learnware/LearnwareEnums';
import { QuestionPassState } from '../QuestionPassState';
export class QuestionPassState_Phase4 extends QuestionPassState {
    id = QuestionPassStateId.Phase4;
    name = 'Vokabeln in Phase 4';
    color = 'primary';
    orderInProgressbar = 10;
}
